import { parseLooseYmd, todayYmd } from "../../features/cases/dates";

// Hearings of a /poinpin entry, each with a sortable `ymd`, oldest first.
// Cached per row object (rows are replaced, not mutated, on refetch).
const cache = new WeakMap();

export const hearingsOf = (row) => {
  if (!row) return [];
  if (cache.has(row)) return cache.get(row);
  const list = (Array.isArray(row.poinika) ? row.poinika : [])
    .map((h) => ({ ...h, ymd: parseLooseYmd(h?.date) }))
    .sort((a, b) => (a.ymd ?? 0) - (b.ymd ?? 0));
  cache.set(row, list);
  return list;
};

// The nearest upcoming hearing, else the most recent one.
export const nextHearing = (row) => {
  const list = hearingsOf(row);
  if (!list.length) return null;
  const today = todayYmd();
  return list.find((h) => h.ymd && h.ymd >= today) ?? list[list.length - 1];
};
